import { LoadingButton } from '@mui/lab';
import { Box, Grid, TextField } from '@mui/material';
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { AuthStore } from '../../../../store/UserStore';
import { CustomDescrypt } from '../../../../utils/MyEncryption';
import SaveIcon from '@mui/icons-material/Save';
import Swal from 'sweetalert2';
import axios from 'axios';
import { base_url } from '../../../../utils/GlobalVariables';

const Form = ({ id_pencairan = null, setId }) => {
    const navigate = useNavigate();
    const encryptUser = localStorage.getItem('AuthPersist');
    const encryptUserJson = JSON.parse(encryptUser);
    const decryptedUser = encryptUserJson.state.user === null ? "" : JSON.parse(CustomDescrypt(encryptUserJson.state.user));
    const [loading, setLoading] = useState(false);
    const logOut = AuthStore((state) => state.logOut);
    const [formData, setFormData] = useState({
        nip: id_pencairan === null ? "" : id_pencairan.nip,
        nama: id_pencairan === null ? "" : id_pencairan.nama,
        pangkat: id_pencairan === null ? "" : id_pencairan.pangkat,
        golongan: id_pencairan === null ? "" : id_pencairan.golongan,
        jabatan: id_pencairan === null ? "" : id_pencairan.jabatan
    });

    const onChangeInput = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        })
        console.log(formData);
    }

    function checkForm(obj) {
        for (var key in obj) {
            if (obj[key] === "")
                return false;
        }
        return true;
    }

    const submitForm = () => {
        const isValid = checkForm(formData);
        if (!isValid) {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Isi semua Input'
            })
            return;
        }

        setLoading(true);
        axios.post(
            base_url + '/admin/bud/insert',
            formData,
            {
                headers: {
                    'Authorization': `Bearer ${decryptedUser.token}`,
                    'content-type': 'multipart/form-data'
                }
            })
            .then((response) => {
                setLoading(false);

                Swal.fire({
                    icon: 'success',
                    title: 'Berhasil',
                    text: response.data.msg
                })

                setFormData({
                    nip: "",
                    nama: "",
                    pangkat: "",
                    golongan: "",
                    jabatan: ""
                });
                navigate("/admin/bud", { replace: true });
            })
            .catch((error) => {
                console.log(error);
                if (error.response.status === 401 && error.response.data.messages === "Access Token Expired") {
                    logOut();
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops..',
                        text: error.response.data.messages.error
                    })
                }
                setLoading(false)
            })
    }

    const updateData = () => {
        formData._method = "PUT"
        console.log(formData);
        setLoading(true);
        axios.post(
            base_url + '/admin/bud/update',
            formData,
            {
                headers: {
                    'Authorization': `Bearer ${decryptedUser.token}`,
                    'content-type': 'multipart/form-data'
                }
            })
            .then((response) => {
                console.log(response);
                setLoading(false);

                Swal.fire({
                    icon: 'success',
                    title: 'Berhasil',
                    text: response.data.msg
                })

                setFormData({
                    nip: "",
                    nama: "",
                    pangkat: "",
                    golongan: "",
                    jabatan: ""
                });
                setId(null);
            })
            .catch((error) => {
                console.log(error);
                if (error.response.status === 401 && error.response.data.messages === "Access Token Expired") {
                    logOut();
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops..',
                        text: error.response.data.messages.error
                    })
                }
                setLoading(false)
            })
    }

    return (
        <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={4}>
                <Grid item xs={12} md={6} sx={{ textAlign: "center" }}>
                    <TextField
                        fullWidth
                        name='nip'
                        id="standard-basic"
                        label="NIP"
                        variant="standard"
                        margin="normal"
                        value={formData.nip}
                        onChange={(e) => onChangeInput(e)}
                        error={formData.nip === "" ? true : false}
                        InputProps={{
                            readOnly: id_pencairan === null ? false : true,
                            type: 'number'
                        }}
                    />
                </Grid>
                <Grid item xs={12} md={6} sx={{ textAlign: "center" }}>
                    <TextField
                        fullWidth
                        name='nama'
                        id="standard-basic"
                        label="Nama"
                        variant="standard"
                        margin="normal"
                        value={formData.nama}
                        onChange={(e) => onChangeInput(e)}
                        error={formData.nama === "" ? true : false}
                    />
                </Grid>
                <Grid item xs={12} md={6} sx={{ textAlign: "center" }}>
                    <TextField
                        fullWidth
                        name='pangkat'
                        id="standard-basic"
                        label="Pangkat"
                        variant="standard"
                        margin="normal"
                        value={formData.pangkat}
                        onChange={(e) => onChangeInput(e)}
                        error={formData.pangkat === "" ? true : false}
                    />
                </Grid>
                <Grid item xs={12} md={6} sx={{ textAlign: "center" }}>
                    <TextField
                        fullWidth
                        name='golongan'
                        id="standard-basic"
                        label="Golongan"
                        variant="standard"
                        margin="normal"
                        value={formData.golongan}
                        onChange={(e) => onChangeInput(e)}
                        error={formData.golongan === "" ? true : false}
                    />
                </Grid>
                <Grid item xs={12} md={6} sx={{ textAlign: "center" }}>
                    <TextField
                        fullWidth
                        name='jabatan'
                        id="standard-basic"
                        label="Jabatan"
                        variant="standard"
                        margin="normal"
                        value={formData.jabatan}
                        onChange={(e) => onChangeInput(e)}
                        error={formData.jabatan === "" ? true : false}
                    />
                </Grid>
            </Grid>
            <Grid container spacing={2} py={2} justifyContent="flex-end">
                <Grid item >
                    <LoadingButton
                        onClick={id_pencairan === null ? submitForm : updateData}
                        loading={loading}
                        variant="contained"
                        margin="normal"
                        loadingPosition="start"
                        startIcon={<SaveIcon />}
                    >
                        {id_pencairan === null ? "Simpan" : "Update"}
                    </LoadingButton>
                </Grid>
            </Grid>
        </Box>
    )
}

export default Form